export const itData = {
  title: 'Informativa sulla Privacy e sui Cookie – Danghuan',
  sections: [
    {
      title: 'Introduzione',
      content: `
        <p>La presente Informativa sulla Privacy e sui Cookie spiega come Danghuan Europe S.L. ("noi", "ci" o "Danghuan") raccoglie, utilizza e protegge i tuoi dati personali quando interagisci con i nostri siti web e servizi. La presente politica si applica ai residenti dello Spazio Economico Europeo (SEE) ed è conforme al Regolamento Generale sulla Protezione dei Dati (GDPR) e alle relative normative nazionali sulla protezione dei dati.</p>
      `
    },
    {
      title: 'Ambito di applicazione della presente politica',
      content: `
        <p>La presente informativa si applica a:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Visitatori del nostro sito web (https://www.danghuan.eu)</li>
          <li style='margin-bottom: 8px;'>Clienti e potenziali clienti</li>
          <li style='margin-bottom: 8px;'>Utenti dei nostri servizi di permuta e rivendita</li>
          <li style='margin-bottom: 8px;'>Rappresentanti di partner commerciali e affiliati di piattaforma</li>
        </ul>
      `
    },
    {
      title: 'Quali dati raccogliamo',
      content: `
        <p>A seconda della tua interazione con noi, potremmo raccogliere:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Nome completo, indirizzo, e-mail e numero di telefono</li>
          <li style='margin-bottom: 8px;'>IBAN, Sort Code e numero di conto, PayPal, Revolut o altri dettagli bancari</li>
          <li style='margin-bottom: 8px;'>Dettagli del dispositivo (modello, marca, stato, informazioni sul prezzo, numero di serie, IMEI)</li>
          <li style='margin-bottom: 8px;'>Cronologia delle comunicazioni con il servizio clienti</li>
          <li style='margin-bottom: 8px;'>Preferenze di marketing e interazioni con le campagne</li>
          <li style='margin-bottom: 8px;'>Indirizzo IP, tipo di browser, ID di sessione e posizione</li>
          <li style='margin-bottom: 8px;'>Dati di piattaforma provenienti da Shopify, Amazon, TEMU, Back Market</li>
        </ul>
        <p>Potremmo ricevere alcuni dati su di te dai nostri partner di piattaforma o logistici (ad es. Shopify, Amazon, Back Market, TEMU) quando interagisci con le loro piattaforme in connessione con i nostri servizi. Ciò include dati relativi all’ordine, indirizzo di spedizione e stato della transazione.</p>
      `
    },
    {
      title: 'Uso dei dati personali',
      content: `
        <p>Utilizziamo i tuoi dati per:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Elaborare gli ordini e gestire la logistica (inclusi resi e operazioni di permuta)</li>
          <li style='margin-bottom: 8px;'>Comunicare con te in merito alle tue transazioni</li>
          <li style='margin-bottom: 8px;'>Fornire assistenza clienti e supporto tecnico</li>
          <li style='margin-bottom: 8px;'>Inviare comunicazioni di marketing (se hai espresso il consenso)</li>
          <li style='margin-bottom: 8px;'>Rispettare gli obblighi legali (ad es. controlli fiscali o antifrode)</li>
          <li style='margin-bottom: 8px;'>Migliorare l’esperienza dell’utente e ottimizzare le nostre piattaforme</li>
        </ul>
      `
    },
    {
      title: 'Cookie',
      content: `
        <p>Utilizziamo i cookie per migliorare la tua esperienza di navigazione e ottimizzare i nostri servizi. I cookie possono raccogliere:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Indirizzo IP e dati di geolocalizzazione</li>
          <li style='margin-bottom: 8px;'>Identificatori del browser/dispositivo</li>
          <li style='margin-bottom: 8px;'>Comportamento d’uso (pagine visualizzate, tempo sul sito, clic)</li>
        </ul>
        <p>Tipologie di cookie:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Cookie strettamente necessari</li>
          <li style='margin-bottom: 8px;'>Cookie funzionali</li>
          <li style='margin-bottom: 8px;'>Cookie di prestazione</li>
          <li style='margin-bottom: 8px;'>Cookie pubblicitari</li>
        </ul>
        <p>Puoi configurare o revocare le impostazioni dei cookie in qualsiasi momento tramite il tuo browser o il banner dei cookie.</p>
      `
    },
    {
      title: 'Terze parti con cui condividiamo i dati',
      content: `
        <p>Condividiamo i dati con partner di pagamento e logistica sulla base della necessità contrattuale e con fornitori di servizi di analisi in base al tuo consenso ai cookie.</p>
        <p>Possiamo condividere i tuoi dati con:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Partner di pagamento: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li style='margin-bottom: 8px;'>Fornitori di logistica: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li style='margin-bottom: 8px;'>Partner di piattaforma: Shopify, Amazon, TEMU, BackMarket</li>
          <li style='margin-bottom: 8px;'>Fornitori di marketing e analisi: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li style='margin-bottom: 8px;'>Fornitori IT, consulenti e consulenti legali</li>
          <li style='margin-bottom: 8px;'>Autorità governative, se richiesto dalla legge.</li>
        </ul>
        <p>I dati possono essere trasferiti al di fuori dello SEE in conformità con le misure di salvaguardia approvate dall’UE, come le Clausole Contrattuali Standard.</p>
      `
    },
    {
      title: 'Uso dei loghi di marchi di terze parti',
      content: `
        <p>Il nostro sito web mostra nomi e loghi di marchi come Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google, Insta360 e altri esclusivamente per identificare dispositivi compatibili ai fini della permuta o della rivendita. Tutti i marchi appartengono ai rispettivi proprietari. Danghuan Europe è un fornitore di servizi indipendente e non è affiliato, approvato o sponsorizzato da tali marchi, salvo ove espressamente indicato. La presenza di questi loghi non implica alcun rapporto commerciale formale.</p>
        <p>L’uso dei loghi di marchi di terze parti è esclusivamente a scopo descrittivo. Tutti i suddetti marchi mantengono i propri diritti e non è implicata alcuna associazione con Danghuan.</p>
      `
    },
    {
      title: 'Conservazione e sicurezza dei dati',
      content: `
        <p>Conserviamo i tuoi dati solo per il tempo necessario a soddisfare gli scopi sopra indicati o come richiesto dalla legge. Applichiamo misure tecniche e organizzative adeguate per proteggere i tuoi dati, inclusi crittografia, controllo degli accessi e archiviazione sicura.</p>
      `
    },
    {
      title: 'I tuoi diritti',
      content: `
        <p>Miriamo a rispondere a tutte le richieste valide relative ai dati entro un mese. Per proteggere la tua privacy, potremmo dover verificare la tua identità prima di elaborare la tua richiesta.</p>
        <p>Hai il diritto di:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Accedere e rettificare i tuoi dati</li>
          <li style='margin-bottom: 8px;'>Richiedere la cancellazione ("diritto all’oblio")</li>
          <li style='margin-bottom: 8px;'>Opporsi o limitare il trattamento</li>
          <li style='margin-bottom: 8px;'>Revocare il consenso in qualsiasi momento</li>
          <li style='margin-bottom: 8px;'>Richiedere la portabilità dei dati (ove applicabile)</li>
        </ul>
        <p>Per esercitare questi diritti, contattaci all’indirizzo <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: 'Aggiornamenti della politica',
      content: `
        <p>Potremmo aggiornare la presente politica per riflettere modifiche ai requisiti legali o alle nostre pratiche di trattamento dei dati. La versione più recente sarà sempre disponibile sul nostro sito web.</p>
      `
    },
    {
      title: 'Contatti',
      content: `
        <p>Se hai domande o desideri esercitare i tuoi diritti, ti preghiamo di contattarci:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'><strong>Danghuan Europe S.L.</strong></li>
          <li style='margin-bottom: 8px;'><strong>Email:</strong> <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li style='margin-bottom: 8px;'><strong>Sito web:</strong> <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>Puoi inoltre proporre reclamo al Garante per la protezione dei dati personali, ai sensi dell’art. 77 del GDPR.</p>
      `
    },
    {
      title: 'Addendum – Informazioni legali e sui cookie estese',
      subsections: [
        {
          title: '1. Basi giuridiche per il trattamento dei dati',
          content: `
            <p>Le basi giuridiche per il trattamento dei tuoi dati personali includono:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Esecuzione di un contratto (ad es. elaborazione di ordini di permuta, invio di pagamenti)</li>
              <li style='margin-bottom: 8px;'>Conformità agli obblighi legali (ad es. dichiarazioni fiscali, verifica dell’identità)</li>
              <li style='margin-bottom: 8px;'>Il tuo consenso (ad es. comunicazioni di marketing o cookie di terze parti)</li>
              <li style='margin-bottom: 8px;'>Interessi legittimi (ad es. prevenzione delle frodi, analisi interne, miglioramento dei servizi)</li>
            </ul>
          `
        },
        {
          title: '2. Misure di prevenzione delle frodi',
          content: `
            <p>Possiamo utilizzare le tue informazioni personali (ad es. numero di serie del dispositivo, modello di transazione, geolocalizzazione IP, titolarità dell’IBAN) per effettuare controlli antifrode utilizzando banche dati pubblicamente disponibili e fornitori di servizi antifrode. Ciò avviene nel rispetto del nostro legittimo interesse a prevenire il furto d’identità e l’uso improprio dei nostri servizi.</p>
            <p>Non prendiamo decisioni basate esclusivamente su processi automatizzati che possano avere un impatto significativo su di te.</p>
          `
        },
        {
          title: '3. Gestione dei dati su marketplace esterni',
          content: `
            <p>Se acquisti o vendi dispositivi tramite piattaforme di terze parti come Amazon, Shopify, TEMU o Back Market, Danghuan può ricevere le informazioni relative all’ordine, l’indirizzo di spedizione e la conferma di pagamento tramite un’API crittografata o un canale di back office sicuro, esclusivamente per finalità di esecuzione della transazione e di supporto post-vendita.</p>
          `
        },
        {
          title: '4. Categorie e dettagli dei cookie',
          content: `
            <p>Puoi consultare l’elenco completo dei cookie che utilizziamo — incluso nome, fornitore, scopo, durata e tipo (cookie di prima o di terza parte) — nella tabella sottostante. Questo include i cookie di analisi di Google Analytics, i cookie di retargeting di Meta e i cookie di pagamento di PayPal.</p>
            <table style='border-collapse: collapse; width: 100%;'>
              <thead>
                <tr>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Categoria</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Nome del cookie</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Fornitore</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Scopo</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Durata</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Tipo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strettamente necessari</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Memorizza le preferenze sui cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 anno</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prima parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strettamente necessari</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mantiene lo stato della sessione tra le pagine</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sessione</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prima parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funzionali</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ricorda la preferenza linguistica</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sessione</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prima parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funzionali</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Abilita il supporto chat live</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>6 mesi</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Terza parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prestazione</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Raccoglie statistiche sull'uso del sito</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 anni</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Terza parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prestazione</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tiene traccia del comportamento dell'utente tra le sessioni</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>24 ore</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Terza parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prestazione</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mantiene la sessione dell'utente tra le pagine</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 anno</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Terza parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Pubblicitari</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Fornisce annunci personalizzati in base al comportamento</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 mesi</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Terza parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Pubblicitari</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tiene traccia delle interazioni e conversioni degli utenti</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>13 mesi</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Terza parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Pubblicitari</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_uetsid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Traccia gli utenti attraverso i siti web per finalità di marketing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 giorno</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Terza parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Pubblicitari</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Utilizzato per il monitoraggio delle conversioni</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 mesi</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Terza parte</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Pubblicitari</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>__kla_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Identifica i visitatori per le campagne di email marketing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 anni</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Terza parte</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: '5. Promozioni, campagne e sondaggi',
          content: `
            <p>Quando partecipi alle nostre promozioni, sondaggi o concorsi, potremmo raccogliere il tuo nome, i dati di contatto e ulteriori informazioni specifiche dell’evento (ad es. età, posizione). Questi dati vengono utilizzati esclusivamente per amministrare l’evento, contattare i vincitori e migliorare le campagne future.</p>
          `
        },
        {
          title: '6. Autorità di controllo',
          content: `
            <p>Puoi presentare un reclamo alle seguenti autorità di controllo se ritieni che i tuoi diritti in materia di protezione dei dati siano stati violati:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>In Italia: Garante per la protezione dei dati personali (Autorità Garante – GPDP) – <a href="https://www.garanteprivacy.it" target="_blank">www.garanteprivacy.it</a></li>
              <li style='margin-bottom: 8px;'>Nell'Unione Europea: puoi trovare l'autorità di controllo nazionale competente per il tuo paese sul sito web del Comitato Europeo per la Protezione dei Dati (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ]
};